export const themeColors = [
	{
		name: 'blue-theme',
		color: '#2563eb', // Modern blue
	},
	{
		name: 'green-theme',
		color: '#059669', // Fresh green
	},
	{
		name: 'purple-theme',
		color: '#7c3aed', // Vibrant purple
	},
	{
		name: 'red-theme',
		color: '#dc2626', // Energetic red
	},
	{
		name: 'indigo-theme',
		color: '#4f46e5', // Rich indigo
	},
	{
		name: 'orange-theme',
		color: '#ea580c', // Warm orange
	},
];

export const AllSenegalDepartments = [
	// Région de Dakar
	'Dakar',
	'Guédiawaye',
	'Pikine',
	'Rufisque',

	// Région de Diourbel
	'Bambey',
	'Diourbel',
	'Mbacké',

	// Région de Fatick
	'Fatick',
	'Foundiougne',
	'Gossas',

	// Région de Kaffrine
	'Birkelane',
	'Kaffrine',
	'Koungheul',
	'Malem-Hodar',

	// Région de Kaolack
	'Guinguinéo',
	'Kaolack',
	'Nioro du Rip',

	// Région de Kédougou
	'Kédougou',
	'Salémata',
	'Saraya',

	// Région de Kolda
	'Kolda',
	'Médina Yoro Foulah',
	'Vélingara',

	// Région de Louga
	'Kébémer',
	'Linguère',
	'Louga',

	// Région de Matam
	'Kanel',
	'Matam',
	'Ranérou-Ferlo',

	// Région de Saint-Louis
	'Dagana',
	'Podor',
	'Saint-Louis',

	// Région de Sédhiou
	'Bounkiling',
	'Goudomp',
	'Sédhiou',

	// Région de Tambacounda
	'Bakel',
	'Goudiry',
	'Koumpentoum',
	'Tambacounda',

	// Région de Thiès
	'Mbour',
	'Thiès',
	'Tivaouane',

	// Région de Ziguinchor
	'Bignona',
	'Oussouye',
	'Ziguinchor',
];
